import React from "react";
import { FormattedMessage } from "react-intl";

interface EmailMktModalProps {
  open: boolean;
  title: React.ReactNode;
  onClose: () => void;
  children: React.ReactNode;
  footer?: React.ReactNode;
  elevated?: boolean;
}

export function EmailMktModal({
  open,
  title,
  onClose,
  children,
  footer,
  elevated = false,
}: EmailMktModalProps) {
  if (!open) {
    return null;
  }

  return (
    <div
      className={
        elevated
          ? "email-mkt__wizard-backdrop email-mkt__wizard-backdrop--elevated"
          : "email-mkt__wizard-backdrop"
      }
      onClick={onClose}
    >
      <div
        className="email-mkt__wizard email-mkt__modal"
        onClick={(event) => event.stopPropagation()}
        role="dialog"
        aria-modal="true"
      >
        <header className="email-mkt__wizard-header">
          <h2>{title}</h2>
          <button type="button" className="email-mkt__ghost-btn" onClick={onClose}>
            <FormattedMessage id="app.emailMarketing.emails.wizard.close" />
          </button>
        </header>
        <div className="email-mkt__wizard-body">{children}</div>
        {footer ? <footer className="email-mkt__wizard-footer">{footer}</footer> : null}
      </div>
    </div>
  );
}
